// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseURL: `${string}://${string}` | (string & {});
};

export type AcceptOrderDto = {
  acceptedByName: string;
  acceptedByCompany: string;
  version: string;
  method: AcceptanceMethod;
};

export const AcceptanceMethod = { ClickThrough: "ClickThrough", SignedDocument: "SignedDocument" } as const;

export type AcceptanceMethod = (typeof AcceptanceMethod)[keyof typeof AcceptanceMethod];

export type AllowedIpPrefixDto = {
  prefix: string;
  description: string;
};

export type AssignSubscriptionToBillingAccountDto = {
  billingAccountCode: string;
};

export const AutoRenewPeriod = { Monthly: "Monthly", Annually: "Annually" } as const;

export type AutoRenewPeriod = (typeof AutoRenewPeriod)[keyof typeof AutoRenewPeriod];

export type BclDateTimeZone = string & {
  originalZone: TimeZoneInfo;
  readonly displayName: string;
};

export type BillingAccountAddressDto = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  countryCode?: string | null;
};

export type BillingAccountDetailDto = BillingAccountDto & {
  contacts: Array<ContactDto>;
  subscriptions: Array<BillingAccountSubscriptionDto>;
  liveOrderCount?: number | null;
  latestIntegrationAttempt?: IntegrationAttemptDto;
};

export type BillingAccountDto = {
  code: string;
  legalName: string;
  commonName: string | null;
  crmCustomerId: string | null;
  zuoraAccountNumber: string | null;
  address: BillingAccountAddressDto;
  attentionFirstName: string;
  attentionLastName: string;
  attentionEmail: string;
  taxId: string | null;
  paymentTerm: PaymentTerm;
  isTaxExempt: boolean;
  taxExemptionCertificateId: string | null;
  taxExemptionCertificateType: string | null;
  taxExemptionJurisdiction: string | null;
  taxExemptionEntityUseCode: string | null;
  taxExemptionDescription: string | null;
  isReseller: boolean;
  hasAddressIssue: boolean;
  hasContactsIssue: boolean;
  contactCount: number;
};

export type BillingAccountDtoListResponse = {
  items: Array<BillingAccountDto | BillingAccountDetailDto | UpdateBillingAccountResultDto>;
  totalItems: number;
  page: number;
  pageSize: number;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
};

export type BillingAccountSubscriptionDto = {
  id: string;
  friendlyName: string | null;
  serial: string;
  dnsPrefix: string | null;
  platform: ProductPlatform;
  planName: string;
  status: SubscriptionStatus;
  termEndDate: string | null;
};

export const BillingAccountTypeFilter = {
  All: "All",
  Customers: "Customers",
  Resellers: "Resellers",
} as const;

export type BillingAccountTypeFilter = (typeof BillingAccountTypeFilter)[keyof typeof BillingAccountTypeFilter];

export type BulkAssignRateCardsRequestDto = {
  assignments: Array<BulkRateCardAssignmentDto>;
};

export type BulkAssignRateCardsResponseDto = {
  succeeded: Array<BulkRateCardAssignmentSuccessDto>;
  failed: Array<BulkRateCardAssignmentFailureDto>;
};

export type BulkRateCardAssignmentDto = {
  subscriptionId?: string | null;
  existingRateCardCode?: string | null;
  newRateCard?: RateCardTermsDto;
  reason?: string | null;
};

export type BulkRateCardAssignmentFailureDto = {
  subscriptionId: string;
  error: string;
};

export type BulkRateCardAssignmentSuccessDto = {
  subscriptionId: string;
  assignmentId: string;
  rateCardId: string;
  rateCardCode: string;
};

export type CachedDateTimeZone = string;

export type CalculateSubscriptionPriceDto = {
  quantities: {
    Project?: number;
    Machine?: number;
    Tenant?: number;
    Target?: number;
  };
  asOf?: string | null;
};

export type CancelSubscriptionRequestDto = {
  reason: string;
};

export type ChangeSubscriptionPlanRequestDto = {
  planId: string;
  clearEntitlementOverrides: boolean;
};

export type CloudSubscriptionDto = {
  id: string;
  serial: string;
  serialHash: string;
  isFulfilled: boolean;
  validFrom: string;
  friendlyName: string;
  salesforceContractId?: string | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
  cloudRegionId: string;
  dnsPrefix: string;
  staticIpPrefixes?: Array<string> | null;
  maintenanceWindow: MaintenanceWindowDto;
  isInstanceProvisioned?: boolean | null;
  cloudSubscriptionStatus: CloudSubscriptionStatus;
  subscriptionGroup?: SubscriptionGroupDto;
  entitlements: CloudSubscriptionEntitlementsDto;
  licensingChannel?: CloudSubscriptionLicensingChannelDto;
  customerSpecifiedMachineLimit?: number | null;
  staffSpecifiedTaskCap?: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  staffSpecifiedTaskCapExpiryUtc?: string | null;
  hasProtectedUserGrants: boolean;
  ipAddressAllowList: IpAddressAllowListDto;
};

export type CloudSubscriptionEntitlementsDto = {
  machineLimit: MachineLimitFeatureDto;
  retentionLimitInDays: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto;
  userLimit: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto;
  projectLimit: IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto;
  tenantLimit?: IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  spaceLimit: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto;
  spaceLevelInsights?: ExpiringFeatureDto;
  auditLogFeeds?: ExpiringFeatureDto;
  serviceNow?: ExpiringFeatureDto;
  jiraServiceManagement?: ExpiringFeatureDto;
  priorityTask?: ExpiringFeatureDto;
  globalDeploymentFreeze?: ExpiringFeatureDto;
  processTemplates?: ExpiringFeatureDto;
  policies?: ExpiringFeatureDto;
  projectTemplates?: ExpiringFeatureDto;
  scim?: ExpiringFeatureDto;
  storageLimitInGb: number;
  taskCap: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto;
  telemetryEnforced?: boolean | null;
  connectionAgentLimit?: number | null;
};

export type CloudSubscriptionLicensingChannelDto = {
  id: string;
  createdDate: string;
  expiryDate?: string | null;
  trialId?: string | null;
  salesforceContractId?: string | null;
  zuoraSubscriptionKey?: string | null;
  renewalPeriod?: CloudSubscriptionRenewalPeriod;
  autoRenew?: boolean | null;
  comment?: string | null;
  subscriptionId?: string | null;
  planName?: string | null;
  status?: SubscriptionStatus;
  termEndDate?: string | null;
};

export const CloudSubscriptionRenewalPeriod = { Monthly: "Monthly", Annually: "Annually" } as const;

export type CloudSubscriptionRenewalPeriod =
  (typeof CloudSubscriptionRenewalPeriod)[keyof typeof CloudSubscriptionRenewalPeriod];

export const CloudSubscriptionStatus = {
  None: "None",
  Subscribed: "Subscribed",
  Lapsed: "Lapsed",
  Cancelled: "Cancelled",
  Terminated: "Terminated",
} as const;

export type CloudSubscriptionStatus = (typeof CloudSubscriptionStatus)[keyof typeof CloudSubscriptionStatus];

export type ComplimentaryLifecycleMetadata = LifecycleMetadata & {
  complimentaryType: ComplimentaryType;
  autoRenewPeriod?: AutoRenewPeriod;
  overrides?: EntitlementConfiguration;
};

export type ComplimentarySubscription = Subscription & {
  complimentaryType: ComplimentaryType;
  autoRenewPeriod?: AutoRenewPeriod;
  entitlementOverrides: EntitlementConfiguration;
};

export const ComplimentaryType = {
  Infrastructure: "Infrastructure",
  Temporary: "Temporary",
  Partner: "Partner",
  Staff: "Staff",
  Gift: "Gift",
} as const;

export type ComplimentaryType = (typeof ComplimentaryType)[keyof typeof ComplimentaryType];

export type ContactDto = {
  id: string;
  firstName: string;
  lastName?: string | null;
  email: string;
  phone?: string | null;
  roles: Array<ContactRole>;
};

export const ContactRole = {
  Billing: "Billing",
  Technical: "Technical",
  Security: "Security",
} as const;

export type ContactRole = (typeof ContactRole)[keyof typeof ContactRole];

export type CountryDto = {
  twoDigitIsoCode: string;
  name: string;
  status: CountryStatus;
  states: Array<StateDto>;
};

export const CountryStatus = {
  Unknown: "Unknown",
  Active: "Active",
  Inactive: "Inactive",
} as const;

export type CountryStatus = (typeof CountryStatus)[keyof typeof CountryStatus];

export type CreateBillingAccountDto = {
  legalName: string;
  commonName?: string | null;
  crmCustomerId?: string | null;
  zuoraAccountNumber?: string | null;
  address?: BillingAccountAddressDto;
  attentionFirstName: string;
  attentionLastName: string;
  attentionEmail: string;
  taxId?: string | null;
  paymentTerm: PaymentTerm;
  taxExemptionCertificateId?: string | null;
  taxExemptionCertificateType?: string | null;
  taxExemptionJurisdiction?: string | null;
  taxExemptionEntityUseCode?: string | null;
  taxExemptionDescription?: string | null;
  isReseller: boolean;
};

export type CreateOrderDto = {
  subscriptionId: string;
  termStartDate?: string | null;
  planId?: string | null;
  rateCardCode?: string | null;
  salesRep?: string | null;
  paymentTerm?: OrderPaymentTerm;
  billingAccountCode?: string | null;
};

export type CreateSubscriptionDto = {
  planId: string;
  ownerUserId?: string | null;
  friendlyName?: string | null;
  platform: OctopusCloudPlatformOptions | OctopusServerPlatformOptions;
  lifecycle:
    | ComplimentaryLifecycleMetadata
    | EvergreenLifecycleMetadata
    | PaidLifecycleMetadata
    | TrialLifecycleMetadata;
  companyName?: string | null;
  newUserFirstName?: string | null;
  newUserLastName?: string | null;
  newUserEmail?: string | null;
  phone?: string | null;
  zuoraSubscriptionKey?: string | null;
  termEndDate?: string | null;
};

export type CreateSubscriptionPlatformOptions = {
  type: ProductPlatform;
};

export type CreateSubscriptionResponse = {
  subscription: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
  product: IIdentifiableBySerial;
};

export const Currency = { USD: "USD" } as const;

export type Currency = (typeof Currency)[keyof typeof Currency];

export type DeactivationRecord = {
  deactivatedAt: string;
  reason: string;
  reactivatedAt?: string | null;
};

export type DomainEventsCollection = {
  [key: string]: never;
};

export type DowngradeToFreeRequestDto = {
  reason: string;
};

export type DraftRateCardAssignmentDto = {
  existingRateCardCode?: string | null;
  newRateCard?: RateCardTermsDto;
  reason: string;
};

export type DraftRateCardAssignmentResponse = {
  assignment: SubscriptionRateCardAssignment;
  rateCard: RateCard;
};

export type EntitlementConfiguration = {
  projects?: IntOrUnlimitedWithCountDisabledUnits;
  tenants?: IntOrUnlimitedWithCountDisabledUnits;
  machines?: IntOrUnlimitedWithCountDisabledUnits;
  targets?: IntOrUnlimited | IntOrUnlimitedWithCountDisabledUnits | null;
  taskCap?: IntOrUnlimited | IntOrUnlimitedWithCountDisabledUnits | null;
  storageLimitGb?: number | null;
  nodes?: IntOrUnlimited | IntOrUnlimitedWithCountDisabledUnits | null;
  retentionDays?: IntOrUnlimited | IntOrUnlimitedWithCountDisabledUnits | null;
  users?: IntOrUnlimited | IntOrUnlimitedWithCountDisabledUnits | null;
  spaces?: IntOrUnlimited | IntOrUnlimitedWithCountDisabledUnits | null;
  telemetryEnforced?: boolean | null;
  serviceNow?: boolean | null;
  spaceLevelInsights?: boolean | null;
  auditLogFeeds?: boolean | null;
  jiraServiceManagement?: boolean | null;
  priorityTask?: boolean | null;
  globalDeploymentFreeze?: boolean | null;
  processTemplates?: boolean | null;
  policies?: boolean | null;
  projectTemplates?: boolean | null;
  scim?: boolean | null;
  connectionAgents?: number | null;
  restrictedPermissions?: boolean | null;
};

export type EntityHistoryReferenceDto = {
  entityId: string;
  entityType: string;
  validFrom: string;
  validTo: string;
  lastModifiedByUser: string;
};

export type EvergreenLifecycleMetadata = LifecycleMetadata & {
  expireOnInactivity: boolean;
  inactivityExpirationDays?: number | null;
  inactivityCancellationDays?: number | null;
  deactivationHistory?: Array<DeactivationRecord> | null;
  overrides?: EntitlementConfiguration;
  reasonForTransitionToEvergreen?: string | null;
};

export type EvergreenSubscription = Subscription & {
  entitlementOverrides: EntitlementConfiguration;
};

export type ExpiringFeatureDto = {
  expiryDate?: string | null;
  neverExpires: boolean;
};

export type ExtendSubscriptionTermRequestDto = {
  extensionType: ExtensionType;
  reason: string;
  newTermEndDate?: string | null;
  daysToAdd?: number | null;
};

export const ExtensionType = { DateBased: "DateBased", TimeBased: "TimeBased" } as const;

export type ExtensionType = (typeof ExtensionType)[keyof typeof ExtensionType];

export type FixedDateTimeZone = string & {
  readonly offset: string;
  readonly name: string;
};

export const FulfillmentContactParty = {
  EndUser: "EndUser",
  Reseller: "Reseller",
  Both: "Both",
} as const;

export type FulfillmentContactParty = (typeof FulfillmentContactParty)[keyof typeof FulfillmentContactParty];

export type FulfillmentHistoryEntryDto = {
  step: FulfillmentStepKind;
  revision: number;
  validFrom: string;
  validTo: string | null;
  isCurrent: boolean;
  modifiedByUser: string;
  isRequired: boolean;
  isComplete: boolean;
  completedAt: string | null;
  details: string | null;
};

export const FulfillmentStepKind = {
  OrderAccepted: "OrderAccepted",
  InternalConfirmation: "InternalConfirmation",
  BillingSetupComplete: "BillingSetupComplete",
  InvoiceBalancePaid: "InvoiceBalancePaid",
  ProvisioningDue: "ProvisioningDue",
  ManualGate: "ManualGate",
} as const;

export type FulfillmentStepKind = (typeof FulfillmentStepKind)[keyof typeof FulfillmentStepKind];

export type GetTrialEntitlementsResponse = {
  cloud: EntitlementConfiguration;
  server: EntitlementConfiguration;
};

export type IIdentifiableBySerial = {
  serial: Serial;
};

export type IntLimitCountDisabledUnitsFeatureDto = IntLimitFeatureDto & {
  countDisabledUnits: boolean;
};

export type IntLimitFeatureDto = {
  isUnlimited: boolean;
  limit?: number | null;
  overrun?: number | null;
};

export type IntOrUnlimited = {
  isUnlimited: boolean;
  limit?: number | null;
};

export type IntOrUnlimitedWithCountDisabledUnits = IntOrUnlimited & {
  countDisabledUnits: boolean;
};

export type IntegrationAttemptDto = {
  id: string;
  system: IntegrationSystem;
  operation: IntegrationOperation;
  status: IntegrationAttemptStatus;
  isStuck: boolean;
  trigger: IntegrationTrigger;
  startedAt: string;
  completedAt?: string | null;
  failureDetail?: string | null;
  startedByUser: string;
  reason?: string | null;
};

export const IntegrationAttemptStatus = {
  InProgress: "InProgress",
  Succeeded: "Succeeded",
  Failed: "Failed",
} as const;

export type IntegrationAttemptStatus = (typeof IntegrationAttemptStatus)[keyof typeof IntegrationAttemptStatus];

export const IntegrationOperation = { PushBillingAccount: "PushBillingAccount" } as const;

export type IntegrationOperation = (typeof IntegrationOperation)[keyof typeof IntegrationOperation];

export const IntegrationSystem = { Zuora: "Zuora", HubSpot: "HubSpot" } as const;

export type IntegrationSystem = (typeof IntegrationSystem)[keyof typeof IntegrationSystem];

export const IntegrationTrigger = { Manual: "Manual" } as const;

export type IntegrationTrigger = (typeof IntegrationTrigger)[keyof typeof IntegrationTrigger];

export const InternalConfirmationState = {
  NotRequired: "NotRequired",
  AwaitingConfirmation: "AwaitingConfirmation",
  Confirmed: "Confirmed",
} as const;

export type InternalConfirmationState = (typeof InternalConfirmationState)[keyof typeof InternalConfirmationState];

export type IpAddressAllowListDto = {
  active: boolean;
  allowedIpPrefixes: Array<AllowedIpPrefixDto>;
};

export const IsoDayOfWeek = {
  None: "None",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
} as const;

export type IsoDayOfWeek = (typeof IsoDayOfWeek)[keyof typeof IsoDayOfWeek];

export type LicenseEmailDefaultRecipientsDto = {
  to: Array<string>;
  cc: Array<string>;
  isReseller: boolean;
  warnings: Array<string>;
};

export type LicenseEmailDto = {
  id: string;
  triggerType: LicenseEmailTriggerType;
  serial: string;
  zuoraSubscriptionKey?: string | null;
  status: LicenseEmailStatus;
  toRecipients: Array<string>;
  ccRecipients: Array<string>;
  bccRecipients: Array<string>;
  isResellerDeal: boolean;
  failureCount: number;
  lastError?: string | null;
  lastAttemptAt?: string | null;
  failureReason?: LicenseEmailFailureReason;
  providerMessageId?: string | null;
  sentAt?: string | null;
  requestedBy: string;
  createdDate: string;
};

export const LicenseEmailFailureReason = {
  XmlGenerationFailed: "XmlGenerationFailed",
  RecipientResolutionFailed: "RecipientResolutionFailed",
  SendGridRejected: "SendGridRejected",
  LicenseDataIncomplete: "LicenseDataIncomplete",
} as const;

export type LicenseEmailFailureReason = (typeof LicenseEmailFailureReason)[keyof typeof LicenseEmailFailureReason];

export const LicenseEmailStatus = {
  Pending: "Pending",
  Sending: "Sending",
  Sent: "Sent",
  Failed: "Failed",
  Suppressed: "Suppressed",
} as const;

export type LicenseEmailStatus = (typeof LicenseEmailStatus)[keyof typeof LicenseEmailStatus];

export const LicenseEmailTriggerType = { AutomatedFulfilment: "AutomatedFulfilment", Manual: "Manual" } as const;

export type LicenseEmailTriggerType = (typeof LicenseEmailTriggerType)[keyof typeof LicenseEmailTriggerType];

export const LicensedMachineType = {
  TentaclePassive: "TentaclePassive",
  TentacleActive: "TentacleActive",
  Ssh: "Ssh",
} as const;

export type LicensedMachineType = (typeof LicensedMachineType)[keyof typeof LicensedMachineType];

export type LifecycleMetadata = {
  lifecycleType: LifecycleType;
};

export const LifecycleType = {
  Trial: "Trial",
  Paid: "Paid",
  Evergreen: "Evergreen",
  Complimentary: "Complimentary",
} as const;

export type LifecycleType = (typeof LifecycleType)[keyof typeof LifecycleType];

export type MachineLimitFeatureDto = IntLimitCountDisabledUnitsFeatureDto & {
  machineTypes?: Array<LicensedMachineType> | null;
};

export type MaintenanceWindowDto = {
  frequency: MaintenanceWindowFrequency;
  startTime: string;
  endTime: string;
  timeZone: string;
  weekOfMonth?: MonthlyMaintenanceWindowWeekOfMonth;
  dayOfWeek?: IsoDayOfWeek;
};

export const MaintenanceWindowFrequency = {
  Daily: "Daily",
  Weekly: "Weekly",
  Monthly: "Monthly",
} as const;

export type MaintenanceWindowFrequency = (typeof MaintenanceWindowFrequency)[keyof typeof MaintenanceWindowFrequency];

export const MonthlyMaintenanceWindowWeekOfMonth = {
  First: "First",
  Second: "Second",
  Third: "Third",
} as const;

export type MonthlyMaintenanceWindowWeekOfMonth =
  (typeof MonthlyMaintenanceWindowWeekOfMonth)[keyof typeof MonthlyMaintenanceWindowWeekOfMonth];

export type OctopusCloudPlatformOptions = CreateSubscriptionPlatformOptions & {
  validFrom: string;
  cloudRegionId: string;
  dnsPrefix: string;
  outageWindowStartUtc: string;
  outageWindowEndUtc: string;
};

export type OctopusServerPlatformOptions = CreateSubscriptionPlatformOptions & {
  validFrom: string;
};

export type OrderAcceptanceDto = {
  method: AcceptanceMethod;
  acceptedAt: string;
  acceptedByName: string;
  acceptedByCompany: string;
  ipAddress: string | null;
  userAgent: string | null;
  signedDocumentReference: string | null;
  recordedByStaffMember: string | null;
  cardPaymentCompletedAt: string | null;
};

export type OrderContactPartyDto = {
  billingAccountCode: string;
  legalName: string;
  commonName: string | null;
  address: BillingAccountAddressDto;
  contacts: Array<ContactDto>;
};

export type OrderContactsDto = {
  isAvailable: boolean;
  endCustomer: OrderContactPartyDto;
  reseller: OrderContactPartyDto;
};

export type OrderDto = OrderSummaryDto & {
  version: string;
  subscriptionSelfServiceEnabled: boolean;
  planId: string;
  rateCardCode: string;
  quantities: Array<OrderQuantityDto>;
  price: PriceBreakdown;
  taxEstimate: OrderTaxEstimateDto;
  validUntilOverride: string | null;
  customAgreementReference: string | null;
  specialLicenceTerms: Array<SpecialLicenceTermDto>;
  preapprovedLegalTermIds: Array<string>;
  internalNotes: string | null;
  requiresManualFulfillmentApproval: boolean;
  reviewReasons: Array<string>;
  internalConfirmationReasons: Array<string>;
  canReopen: boolean;
  reopenBlockedByBillingAccountChange: boolean;
  blockingQuoteOdNumber: string | null;
  purchaseOrderNumber: string | null;
  fulfillmentContact: FulfillmentContactParty;
  acceptance: OrderAcceptanceDto;
  entitlements: EntitlementConfiguration;
};

export type OrderFulfillmentDto = {
  isAvailable: boolean;
  unavailableReason: string | null;
  fulfillmentId: string | null;
  isFrozen: boolean;
  provisioningDueDate: string | null;
  provisionedAt: string | null;
  steps: Array<OrderFulfillmentStepDto>;
};

export type OrderFulfillmentStepDto = {
  kind: FulfillmentStepKind;
  isRequired: boolean;
  isComplete: boolean;
  completedAt: string | null;
  details: string | null;
  canComplete: boolean;
  canReopen: boolean;
  lastModifiedByUser: string;
};

export type OrderFulfillmentSummaryDto = {
  isAvailable: boolean;
  isFrozen: boolean;
  provisionedAt: string | null;
  outstandingRequiredSteps: Array<FulfillmentStepKind>;
};

export type OrderHistoryEntryDto = {
  revision: number;
  validFrom: string;
  validTo: string | null;
  isCurrent: boolean;
  modifiedByUser: string;
  status: OrderStatus;
  currency: Currency;
  total: number;
  validUntil: string | null;
  requiresInternalConfirmation: boolean;
  reviewRequired: boolean;
  isArchived: boolean;
};

export type OrderInternalConfirmationDto = {
  isRequired: boolean;
  note: string | null;
  state: InternalConfirmationState;
  confirmedAt: string | null;
  confirmedByUser: string | null;
};

export const OrderPaymentTerm = {
  DueUponReceipt: "DueUponReceipt",
  Net30: "Net30",
  Net45: "Net45",
  Net60: "Net60",
  Net90: "Net90",
} as const;

export type OrderPaymentTerm = (typeof OrderPaymentTerm)[keyof typeof OrderPaymentTerm];

export type OrderQuantityDto = {
  vector: PricingVector;
  pricedValue: number;
  measuredValue: number | null;
  measuredAt: string | null;
  overrideReason: string | null;
  isOverridden: boolean;
};

export type OrderQuantityInputDto = {
  vector: PricingVector;
  pricedValue: number;
  overrideReason?: string | null;
};

export type OrderRateCardOperationsDto = {
  canClone: boolean;
  cloneUnavailableReason: string | null;
  canAssignDefault: boolean;
  assignDefaultUnavailableReason: string | null;
  defaultRateCardCode: string | null;
};

export type OrderResellerDto = {
  code: string;
  legalName: string;
  commonName: string | null;
};

export type OrderResellersDto = {
  resellers: Array<OrderResellerDto>;
  hasMoreMatches: boolean;
};

export const OrderStatus = {
  New: "New",
  Quote: "Quote",
  Accepted: "Accepted",
  Cancelled: "Cancelled",
  Expired: "Expired",
} as const;

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];

export type OrderSummaryDto = {
  odNumber: string;
  status: OrderStatus;
  salesMotion: SalesMotion;
  platform: ProductPlatform;
  planName: string;
  currentPlanName: string;
  subscriptionId: string;
  subscriptionName: string | null;
  subscriptionShortId: string;
  subscriptionSerial: string | null;
  billingAccountCode: string;
  billingAccountLegalName: string;
  billingAccountCrmId: string | null;
  isViaReseller: boolean;
  resellerBillingAccountCode: string | null;
  resellerBillingAccountLegalName: string | null;
  termStartDate: string;
  termEndDate: string;
  validUntil: string | null;
  publishedAt: string | null;
  currency: Currency;
  total: number;
  paymentTerm: OrderPaymentTerm;
  salesRep: string | null;
  salesRepEmail: string | null;
  isSelfServe: boolean;
  reviewRequired: boolean;
  isComplicated: boolean;
  isArchived: boolean;
  archivedAt: string | null;
  acceptedAt: string | null;
  internalConfirmation: OrderInternalConfirmationDto;
  fulfillment: OrderFulfillmentSummaryDto;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type OrderSummaryDtoListResponse = {
  items: Array<OrderSummaryDto | OrderDto>;
  totalItems: number;
  page: number;
  pageSize: number;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
};

export type OrderTaxEstimateDto = {
  estimatedTaxAmount: number;
  estimatedTotalIncludingTax: number;
  calculatedAt: string;
  validity?: TaxEstimateValidity;
};

export type OrderTaxEstimatePreviewResultDto = {
  outcome: TaxEstimatePreviewOutcome;
  taxEstimate?: OrderTaxEstimateDto;
};

export type PaidLifecycleMetadata = LifecycleMetadata & {
  billingAttributes?: EntitlementConfiguration;
  reasonForTransitionToPaid?: string | null;
};

export type PaidSubscription = Subscription & {
  readonly zuoraSubscriptionKey?: string | null;
  readonly salesforceContractId?: string | null;
  readonly isTermEndDateEditable: boolean;
  entitlementOverrides: EntitlementConfiguration;
};

export const PaymentTerm = {
  DueUponReceipt: "DueUponReceipt",
  Net30: "Net30",
  Net45: "Net45",
  Net60: "Net60",
  Net75: "Net75",
  Net90: "Net90",
} as const;

export type PaymentTerm = (typeof PaymentTerm)[keyof typeof PaymentTerm];

export type Plan = {
  id: string;
  name: string;
  displayName: string;
  productPlatform: ProductPlatform;
  tier: Tier;
  supersededByPlanId?: string | null;
  availableToDate?: string | null;
  planInclusions: EntitlementConfiguration;
  zuoraRatePlanCodePatternMatch?: string | null;
  defaultNewRateCardId?: string | null;
  defaultRenewalRateCardId?: string | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
  readonly isSuperseded: boolean;
  readonly clearsEntitlementOverrides: boolean;
};

export type PlanListResponse = {
  items: Array<Plan>;
  totalItems: number;
  page: number;
  pageSize: number;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
};

export type PreapprovedLegalTermDto = {
  id: string;
  name: string;
  text: string;
  sortOrder: number;
  isAvailable: boolean;
};

export type PrecalculatedDateTimeZone = string;

export type PreviewOrderPriceDto = {
  quantities: {
    Project?: number;
    Machine?: number;
    Tenant?: number;
    Target?: number;
  };
};

export type PreviewSubscriptionPriceDto = {
  rateCardCode: string;
  quantities: {
    Project?: number;
    Machine?: number;
    Tenant?: number;
    Target?: number;
  };
};

export type PriceBreakdown = {
  currency: Currency;
  lines: Array<PriceLine>;
  fixedFees: Array<RateCardFixedFee>;
  subtotal: number;
  overallDiscount: number;
  total: number;
  readonly effectiveOverallDiscountFraction: number;
};

export type PriceLine = {
  vector: PricingVector;
  quantity: number;
  listUnitPrice: number;
  discountedUnitPrice: number;
  discountFraction: number;
  lineTotal: number;
};

export const PricingVector = {
  Project: "Project",
  Machine: "Machine",
  Tenant: "Tenant",
  Target: "Target",
} as const;

export type PricingVector = (typeof PricingVector)[keyof typeof PricingVector];

export const ProductPlatform = { OctopusServer: "OctopusServer", OctopusCloud: "OctopusCloud" } as const;

export type ProductPlatform = (typeof ProductPlatform)[keyof typeof ProductPlatform];

export type PushBillingAccountToBillingSystemDto = {
  reason: string;
};

export type PushBillingAccountToBillingSystemResultDto = {
  zuoraAccountNumber: string;
  legalName: string;
  additionalEmailAddresses: Array<string>;
  taxRecalculations?: Array<QuoteTaxRecalculationDto> | null;
};

export type QuoteDocumentAcceptance = {
  acceptedByName: string;
  acceptedByCompany: string;
  acceptedAt: string;
};

export type QuoteDocumentAddress = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  countryCode: string;
  countryName: string;
};

export type QuoteDocumentContent = {
  odNumber: string;
  quoteNumber: string;
  salesMotion: SalesMotion;
  platform: ProductPlatform;
  termStartDate: string;
  termEndDate: string;
  validUntil?: string | null;
  quoteDateLabel: string;
  validUntilLabel?: string | null;
  licenceTermLabel: string;
  billingScheduleLabel: string;
  paymentTermLabel: string;
  purchaseOrderNumber?: string | null;
  salesRepresentative?: string | null;
  fulfillmentContactLabel?: string | null;
  productName: string;
  subscriptionSummary: string;
  priceSectionHeading: string;
  renewalPricingHeading: string;
  renewalPricingParagraphs: Array<string>;
  price: QuoteDocumentPriceContent;
  specialLicenceTerms: Array<QuoteDocumentSpecialTerm>;
  customAgreementReference?: string | null;
  acceptance?: QuoteDocumentAcceptance;
  termsAndConditions: Array<QuoteDocumentTermsBullet>;
  title: string;
  acceptanceStatement: string;
  asksForSignature: boolean;
  legalTerms: Array<QuoteDocumentLegalTerm>;
  customerInformation: QuoteDocumentCustomerInformation;
  seller: QuoteDocumentSeller;
  billTo?: QuoteDocumentParty;
  attentionName?: string | null;
  reseller?: QuoteDocumentParty;
};

export type QuoteDocumentCustomerInformation = {
  purchaseOrderNumber?: string | null;
  taxId?: string | null;
  taxExemptionCertificateId?: string | null;
  billingContactName?: string | null;
  billingContactEmail?: string | null;
};

export type QuoteDocumentFixedFee = {
  description: string;
  amount: number;
};

export type QuoteDocumentLegalTerm = {
  name: string;
  text: string;
};

export type QuoteDocumentParty = {
  legalName: string;
  commonName?: string | null;
  address?: QuoteDocumentAddress;
};

export type QuoteDocumentPriceContent = {
  currency: Currency;
  lines: Array<QuoteDocumentPriceLine>;
  fixedFees: Array<QuoteDocumentFixedFee>;
  subtotal: number;
  overallDiscount: number;
  total: number;
  tax?: QuoteDocumentTax;
};

export type QuoteDocumentPriceLine = {
  vector: PricingVector;
  quantity: number;
  listUnitPrice: number;
  discountFraction: number;
  lineTotal: number;
  description: string;
};

export type QuoteDocumentSeller = {
  legalName: string;
  taxIdLabel: string;
  taxId: string;
  phone: string;
  addressLines: Array<string>;
};

export type QuoteDocumentSpecialTerm = {
  title: string;
  text: string;
};

export type QuoteDocumentTax = {
  estimatedTaxAmount: number;
  estimatedTotalIncludingTax: number;
  caveat: string;
};

export type QuoteDocumentTermsBullet = {
  textBefore: string;
  linkText?: string | null;
  linkUrl?: string | null;
  textAfter?: string | null;
};

export type QuoteTargetDto = {
  subscriptionId: string;
  subscriptionName: string | null;
  subscriptionShortId: string;
  serial: string;
  platform: ProductPlatform;
  planName: string;
  planId: string;
  quotedPlanId: string | null;
  quotedPlanName: string | null;
  billingAccountCode: string | null;
  billingAccountLegalName: string | null;
  suggestedSalesMotion: SalesMotion;
  selfServiceEnabled: boolean;
  existingQuoteOdNumber: string | null;
};

export type QuoteTargetSearchResultDto = {
  term: string;
  termKind: QuoteTargetSearchTermKind;
  targets: Array<QuoteTargetDto>;
  hasMoreMatches: boolean;
  resultLimit: number;
};

export const QuoteTargetSearchTermKind = {
  SubscriptionShortId: "SubscriptionShortId",
  SubscriptionId: "SubscriptionId",
  LicenceKey: "LicenceKey",
  CustomerName: "CustomerName",
} as const;

export type QuoteTargetSearchTermKind = (typeof QuoteTargetSearchTermKind)[keyof typeof QuoteTargetSearchTermKind];

export type QuoteTaxRecalculationDto = {
  odNumber: string;
  recalculated: boolean;
  outcome: TaxEstimatePreviewOutcome;
};

export type RateCard = {
  readonly id: string;
  code: string;
  label?: string | null;
  currency: Currency;
  unitPrices: Array<RateCardUnitPrice>;
  discountExponent: number;
  discountThresholdUnits: number;
  fixedFees: Array<RateCardFixedFee>;
  overallDiscountFraction: number;
  finalPriceRoundDownToNearest?: number | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type RateCardAssignmentHistoryEntry = {
  assignmentId: string;
  status: RateCardAssignmentStatus;
  effectiveFrom?: string | null;
  effectiveTo?: string | null;
  reason: string;
  createdByUser: string;
  createdDate: string;
  rateCardId: string;
  rateCardCode: string;
  label?: string | null;
  currency: Currency;
  unitPrices: Array<RateCardUnitPrice>;
  discountExponent: number;
  discountThresholdUnits: number;
  fixedFees: Array<RateCardFixedFee>;
  overallDiscountFraction: number;
  finalPriceRoundDownToNearest?: number | null;
};

export const RateCardAssignmentStatus = {
  Draft: "Draft",
  Active: "Active",
  Superseded: "Superseded",
} as const;

export type RateCardAssignmentStatus = (typeof RateCardAssignmentStatus)[keyof typeof RateCardAssignmentStatus];

export type RateCardFixedFee = {
  description: string;
  amount: number;
};

export type RateCardFixedFeeDto = {
  description?: string | null;
  amount: number;
};

export type RateCardListResponse = {
  items: Array<RateCard>;
  totalItems: number;
  page: number;
  pageSize: number;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
};

export type RateCardTermsDto = {
  label?: string | null;
  currency: Currency;
  unitPrices?: Array<RateCardUnitPriceDto> | null;
  discountExponent: number;
  discountThresholdUnits: number;
  fixedFees?: Array<RateCardFixedFeeDto> | null;
  overallDiscountFraction: number;
  finalPriceRoundDownToNearest?: number | null;
};

export type RateCardUnitPrice = {
  vector: PricingVector;
  listPricePerUnit: number;
};

export type RateCardUnitPriceDto = {
  vector: PricingVector;
  listPricePerUnit: number;
};

export type ReactivateSubscriptionRequestDto = {
  newTermStart: string;
  newTermEnd?: string | null;
};

export type RedactContactDto = {
  reason: string;
};

export const SalesMotion = { New: "New", Renewal: "Renewal" } as const;

export type SalesMotion = (typeof SalesMotion)[keyof typeof SalesMotion];

export type SaveContactDto = {
  firstName: string;
  lastName?: string | null;
  email: string;
  phone?: string | null;
  roles: Array<ContactRole>;
};

export type SendLicenseEmailRequestDto = {
  to: Array<string>;
  cc: Array<string>;
  bcc: Array<string>;
};

export type Serial = {
  id: string;
  hash: string;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type ServerLicenseDto = {
  id: string;
  serial: string;
  serialHash: string;
  isFulfilled: boolean;
  validFromDate: string;
  expiryDate: string;
  salesforceContractId?: string | null;
  licensingChannel?: ServerLicensingChannelDto;
  friendlyName?: string | null;
  createdByUser?: string | null;
  createdDate?: string | null;
  lastModifiedByUser?: string | null;
  lastModifiedDate?: string | null;
  entitlements: ServerLicenseEntitlementsDto;
  subscriptionGroup?: SubscriptionGroupDto;
};

export type ServerLicenseEntitlementsDto = {
  machineLimit: MachineLimitFeatureDto;
  projectLimit?: IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  tenantLimit?: IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  userLimit?: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  workerLimit?: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  spaceLimit?: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  nodeLimit?: IntLimitFeatureDto | IntLimitCountDisabledUnitsFeatureDto | MachineLimitFeatureDto | null;
  taskCap?: number | null;
  telemetryEnforced?: boolean | null;
  restrictedPermissions?: boolean | null;
  serviceNow?: ExpiringFeatureDto;
  spaceLevelInsights?: ExpiringFeatureDto;
  auditLogFeeds?: ExpiringFeatureDto;
  jiraServiceManagement?: ExpiringFeatureDto;
  priorityTask?: ExpiringFeatureDto;
  globalDeploymentFreeze?: ExpiringFeatureDto;
  processTemplates?: ExpiringFeatureDto;
  policies?: ExpiringFeatureDto;
  projectTemplates?: ExpiringFeatureDto;
  scim?: ExpiringFeatureDto;
};

export type ServerLicensingChannelDto = {
  id: string;
  createdDate: string;
  expiryDate?: string | null;
  nextRenewalDate?: string | null;
  trialId?: string | null;
  salesforceContractId?: string | null;
  zuoraSubscriptionKey?: string | null;
  cancelAtPeriodEnd?: boolean | null;
  subscriptionId?: string | null;
  planName?: string | null;
  status?: SubscriptionStatus;
};

export type SetInternalConfirmationDto = {
  requiresInternalConfirmation: boolean;
  note?: string | null;
};

export const SortDirection = { Asc: "Asc", Desc: "Desc" } as const;

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];

export type SpecialLicenceTermDto = {
  title: string;
  text: string;
};

export type StateDto = {
  twoDigitIsoCode: string;
  name: string;
};

export type Subscription = {
  readonly id: string;
  readonly shortId: string;
  ownerUserId: string;
  ownerUser: User;
  readonly planId: string;
  plan: Plan;
  status: SubscriptionStatus;
  lifecycleType: LifecycleType;
  complimentaryTypeValue?: ComplimentaryType;
  readonly friendlyName?: string | null;
  readonly termStartDate?: string | null;
  readonly termEndDate?: string | null;
  readonly trialStarted?: string | null;
  readonly trialFinished?: string | null;
  readonly firstPaid?: string | null;
  readonly expiredOn?: string | null;
  readonly cancelledOn?: string | null;
  readonly lastReactivatedAt?: string | null;
  readonly cancelledReason?: string | null;
  readonly zuoraSubscriptionKey?: string | null;
  readonly trialId?: string | null;
  readonly isVoided: boolean;
  readonly selfServiceEnabled: boolean;
  readonly isTermEndDateEditable: boolean;
  readonly billingAccountId?: string | null;
  billingAccountCode?: string | null;
  billingAccountName?: string | null;
  applicableEntitlementOverrideKeys: Array<string>;
  readonly temporaryUpgradePlanId?: string | null;
  temporaryUpgradePlan?: Plan;
  readonly temporaryUpgradeStartDate?: string | null;
  readonly temporaryUpgradeEndDate?: string | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
  domainEvents: DomainEventsCollection;
  readonly extensions?: Array<TermExtension> | null;
  readonly deactivationHistory?: Array<DeactivationRecord> | null;
};

export type SubscriptionGroupDto = {
  id?: string | null;
  name?: string | null;
};

export type SubscriptionRateCardAssignment = {
  readonly id: string;
  subscriptionId: string;
  rateCardId: string;
  status: RateCardAssignmentStatus;
  readonly effectiveFrom?: string | null;
  readonly effectiveTo?: string | null;
  reason: string;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export const SubscriptionStatus = {
  Pending: "Pending",
  Active: "Active",
  Expired: "Expired",
  Canceled: "Canceled",
} as const;

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export type SubscriptionTransferPreviewDto = {
  draftQuoteCount: number;
  liveQuoteOdNumber?: string | null;
  liveQuoteBillingAccountCode?: string | null;
};

export type SubscriptionWithSerial = {
  id: string;
  serial: string;
  dnsPrefix?: string | null;
  subscription: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type SubscriptionWithSerialListResponse = {
  items: Array<SubscriptionWithSerial>;
  totalItems: number;
  page: number;
  pageSize: number;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
};

export const TaxEstimatePreviewOutcome = {
  Saved: "Saved",
  NoAddressToCalculateTaxAgainst: "NoAddressToCalculateTaxAgainst",
  SubscriptionNotYetInZuora: "SubscriptionNotYetInZuora",
  ZuoraPreviewUnavailable: "ZuoraPreviewUnavailable",
  PreviewedPriceDidNotMatchTheQuote: "PreviewedPriceDidNotMatchTheQuote",
} as const;

export type TaxEstimatePreviewOutcome = (typeof TaxEstimatePreviewOutcome)[keyof typeof TaxEstimatePreviewOutcome];

export const TaxEstimateValidity = {
  Valid: "Valid",
  PriceChanged: "PriceChanged",
  AddressChanged: "AddressChanged",
  Unverifiable: "Unverifiable",
} as const;

export type TaxEstimateValidity = (typeof TaxEstimateValidity)[keyof typeof TaxEstimateValidity];

export type TermExtension = {
  extendedAt: string;
  extendedBy: string;
  reason: string;
  previousTermEndDate: string;
  newTermEndDate: string;
  extensionType: ExtensionType;
  daysAdded?: number | null;
};

export const Tier = {
  Free: "Free",
  Starter: "Starter",
  Professional: "Professional",
  Enterprise: "Enterprise",
  EnterpriseUnlimited: "EnterpriseUnlimited",
  PlatformFee: "PlatformFee",
} as const;

export type Tier = (typeof Tier)[keyof typeof Tier];

export type TimeZoneInfo = {
  readonly id: string;
  readonly hasIanaId: boolean;
  readonly displayName: string;
  readonly standardName: string;
  readonly daylightName: string;
  readonly baseUtcOffset: string;
  readonly supportsDaylightSavingTime: boolean;
};

export type TransitionToComplimentaryRequestDto = {
  complimentaryType: ComplimentaryType;
  autoRenewPeriod?: AutoRenewPeriod;
  termStartDate: string;
  termEndDate?: string | null;
  reason: string;
};

export type TransitionToEvergreenRequestDto = {
  reason: string;
};

export type TransitionToPaidRequestDto = {
  planId: string;
  zuoraSubscriptionKey: string;
  termStartDate: string;
  termEndDate: string;
  reason: string;
};

export type TransitionToTrialRequestDto = {
  termStartDate: string;
  termEndDate: string;
  reason: string;
};

export type TrialLifecycleMetadata = LifecycleMetadata & {
  overrides?: EntitlementConfiguration;
  reasonForTransitionToTrial?: string | null;
};

export type TrialSubscription = Subscription & {
  entitlementOverrides: EntitlementConfiguration;
};

export type UpdateBillingAccountDto = {
  legalName: string;
  commonName?: string | null;
  crmCustomerId?: string | null;
  zuoraAccountNumber?: string | null;
  address?: BillingAccountAddressDto;
  attentionFirstName: string;
  attentionLastName: string;
  attentionEmail: string;
  taxId?: string | null;
  paymentTerm: PaymentTerm;
  taxExemptionCertificateId?: string | null;
  taxExemptionCertificateType?: string | null;
  taxExemptionJurisdiction?: string | null;
  taxExemptionEntityUseCode?: string | null;
  taxExemptionDescription?: string | null;
};

export type UpdateBillingAccountResultDto = BillingAccountDetailDto & {
  taxRecalculations?: Array<QuoteTaxRecalculationDto> | null;
};

export type UpdateComplimentaryAutoRenewalRequest = {
  id: string;
  autoRenewPeriod?: AutoRenewPeriod;
};

export type UpdateOrderDto = {
  version?: string | null;
  planId: string;
  rateCardCode: string;
  termStartDate: string;
  paymentTerm: OrderPaymentTerm;
  quantities: Array<OrderQuantityInputDto>;
  salesRep?: string | null;
  resellerBillingAccountCode?: string | null;
  purchaseOrderNumber?: string | null;
  fulfillmentContact?: FulfillmentContactParty;
  validUntil?: string | null;
  customAgreementReference?: string | null;
  preapprovedLegalTermIds?: Array<string> | null;
  specialLicenceTerms?: Array<SpecialLicenceTermDto> | null;
  internalNotes?: string | null;
  requiresManualFulfillmentApproval: boolean;
};

export type UpdateSelfServiceEnabledRequestDto = {
  selfServiceEnabled: boolean;
};

export type UpdateSubscriptionEntitlementOverridesRequestDto = {
  entitlementOverrides: EntitlementConfiguration;
};

export type UpdateSubscriptionRequestDto = {
  friendlyName?: string | null;
  termEndDate?: string | null;
  ownerUserId?: string | null;
};

export type UpdateZuoraSubscriptionKeyRequestDto = {
  zuoraSubscriptionKey?: string | null;
};

export type User = {
  id: string;
  readonly email?: string | null;
  readonly normalisedEmail?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  octopusIdId?: string | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
  readonly hasProfile: boolean;
};

export type BclDateTimeZoneWritable = string;

export type BillingAccountDtoListResponseWritable = {
  items: Array<BillingAccountDto | BillingAccountDetailDto | UpdateBillingAccountResultDto>;
  totalItems: number;
  page: number;
  pageSize: number;
};

export type ComplimentarySubscriptionWritable = SubscriptionWritable & {
  complimentaryType: ComplimentaryType;
  autoRenewPeriod?: AutoRenewPeriod;
  entitlementOverrides: EntitlementConfiguration;
};

export type CreateSubscriptionResponseWritable = {
  subscription:
    | ComplimentarySubscriptionWritable
    | EvergreenSubscriptionWritable
    | PaidSubscriptionWritable
    | TrialSubscriptionWritable;
  product: IIdentifiableBySerial;
};

export type DraftRateCardAssignmentResponseWritable = {
  assignment: SubscriptionRateCardAssignmentWritable;
  rateCard: RateCardWritable;
};

export type EvergreenSubscriptionWritable = SubscriptionWritable & {
  entitlementOverrides: EntitlementConfiguration;
};

export type OrderDtoWritable = OrderSummaryDto & {
  version: string;
  subscriptionSelfServiceEnabled: boolean;
  planId: string;
  rateCardCode: string;
  quantities: Array<OrderQuantityDto>;
  price: PriceBreakdownWritable;
  taxEstimate: OrderTaxEstimateDto;
  validUntilOverride: string | null;
  customAgreementReference: string | null;
  specialLicenceTerms: Array<SpecialLicenceTermDto>;
  preapprovedLegalTermIds: Array<string>;
  internalNotes: string | null;
  requiresManualFulfillmentApproval: boolean;
  reviewReasons: Array<string>;
  internalConfirmationReasons: Array<string>;
  canReopen: boolean;
  reopenBlockedByBillingAccountChange: boolean;
  blockingQuoteOdNumber: string | null;
  purchaseOrderNumber: string | null;
  fulfillmentContact: FulfillmentContactParty;
  acceptance: OrderAcceptanceDto;
  entitlements: EntitlementConfiguration;
};

export type OrderSummaryDtoListResponseWritable = {
  items: Array<OrderSummaryDto | OrderDtoWritable>;
  totalItems: number;
  page: number;
  pageSize: number;
};

export type PaidSubscriptionWritable = SubscriptionWritable & {
  entitlementOverrides: EntitlementConfiguration;
};

export type PlanWritable = {
  id: string;
  name: string;
  displayName: string;
  productPlatform: ProductPlatform;
  tier: Tier;
  supersededByPlanId?: string | null;
  availableToDate?: string | null;
  planInclusions: EntitlementConfiguration;
  zuoraRatePlanCodePatternMatch?: string | null;
  defaultNewRateCardId?: string | null;
  defaultRenewalRateCardId?: string | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type PlanListResponseWritable = {
  items: Array<PlanWritable>;
  totalItems: number;
  page: number;
  pageSize: number;
};

export type PriceBreakdownWritable = {
  currency: Currency;
  lines: Array<PriceLine>;
  fixedFees: Array<RateCardFixedFee>;
  subtotal: number;
  overallDiscount: number;
  total: number;
};

export type RateCardWritable = {
  code: string;
  label?: string | null;
  currency: Currency;
  unitPrices: Array<RateCardUnitPrice>;
  discountExponent: number;
  discountThresholdUnits: number;
  fixedFees: Array<RateCardFixedFee>;
  overallDiscountFraction: number;
  finalPriceRoundDownToNearest?: number | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type RateCardListResponseWritable = {
  items: Array<RateCardWritable>;
  totalItems: number;
  page: number;
  pageSize: number;
};

export type SubscriptionWritable = {
  ownerUserId: string;
  ownerUser: UserWritable;
  plan: PlanWritable;
  status: SubscriptionStatus;
  lifecycleType: LifecycleType;
  complimentaryTypeValue?: ComplimentaryType;
  billingAccountCode?: string | null;
  billingAccountName?: string | null;
  applicableEntitlementOverrideKeys: Array<string>;
  temporaryUpgradePlan?: PlanWritable;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
  domainEvents: DomainEventsCollection;
};

export type SubscriptionRateCardAssignmentWritable = {
  subscriptionId: string;
  rateCardId: string;
  status: RateCardAssignmentStatus;
  reason: string;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type SubscriptionWithSerialWritable = {
  id: string;
  serial: string;
  dnsPrefix?: string | null;
  subscription:
    | ComplimentarySubscriptionWritable
    | EvergreenSubscriptionWritable
    | PaidSubscriptionWritable
    | TrialSubscriptionWritable;
};

export type SubscriptionWithSerialListResponseWritable = {
  items: Array<SubscriptionWithSerialWritable>;
  totalItems: number;
  page: number;
  pageSize: number;
};

export type TrialSubscriptionWritable = SubscriptionWritable & {
  entitlementOverrides: EntitlementConfiguration;
};

export type UserWritable = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  octopusIdId?: string | null;
  createdByUser: string;
  createdDate: string;
  lastModifiedByUser: string;
  lastModifiedDate: string;
};

export type GetV2BillingAccountsData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    type?: BillingAccountTypeFilter;
    page?: number;
    pageSize?: number;
    sortFieldName?: string;
    sortDirection?: SortDirection;
  };
  url: "/v2/billing-accounts";
};

export type GetV2BillingAccountsResponses = {
  /**
   * OK
   */
  200: BillingAccountDtoListResponse;
};

export type GetV2BillingAccountsResponse = GetV2BillingAccountsResponses[keyof GetV2BillingAccountsResponses];

export type PostV2BillingAccountsData = {
  body?: CreateBillingAccountDto;
  path?: never;
  query?: never;
  url: "/v2/billing-accounts";
};

export type PostV2BillingAccountsResponses = {
  /**
   * OK
   */
  200: BillingAccountDetailDto | UpdateBillingAccountResultDto;
};

export type PostV2BillingAccountsResponse = PostV2BillingAccountsResponses[keyof PostV2BillingAccountsResponses];

export type GetV2BillingAccountsByCodeData = {
  body?: never;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}";
};

export type GetV2BillingAccountsByCodeResponses = {
  /**
   * OK
   */
  200: BillingAccountDetailDto | UpdateBillingAccountResultDto;
};

export type GetV2BillingAccountsByCodeResponse =
  GetV2BillingAccountsByCodeResponses[keyof GetV2BillingAccountsByCodeResponses];

export type PutV2BillingAccountsByCodeData = {
  body?: UpdateBillingAccountDto;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}";
};

export type PutV2BillingAccountsByCodeResponses = {
  /**
   * OK
   */
  200: UpdateBillingAccountResultDto;
};

export type PutV2BillingAccountsByCodeResponse =
  PutV2BillingAccountsByCodeResponses[keyof PutV2BillingAccountsByCodeResponses];

export type GetV2BillingAccountsByCodeHistoryData = {
  body?: never;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/history";
};

export type GetV2BillingAccountsByCodeHistoryResponses = {
  /**
   * OK
   */
  200: Array<EntityHistoryReferenceDto>;
};

export type GetV2BillingAccountsByCodeHistoryResponse =
  GetV2BillingAccountsByCodeHistoryResponses[keyof GetV2BillingAccountsByCodeHistoryResponses];

export type GetV2BillingAccountsByCodeHistorySnapshotData = {
  body?: never;
  path: {
    code: string;
  };
  query?: {
    asOf?: string;
  };
  url: "/v2/billing-accounts/{code}/history-snapshot";
};

export type GetV2BillingAccountsByCodeHistorySnapshotResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type PostV2BillingAccountsByCodeContactsData = {
  body?: SaveContactDto;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/contacts";
};

export type PostV2BillingAccountsByCodeContactsResponses = {
  /**
   * OK
   */
  200: ContactDto;
};

export type PostV2BillingAccountsByCodeContactsResponse =
  PostV2BillingAccountsByCodeContactsResponses[keyof PostV2BillingAccountsByCodeContactsResponses];

export type PostV2BillingAccountsByCodePushToBillingSystemData = {
  body?: PushBillingAccountToBillingSystemDto;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/push-to-billing-system";
};

export type PostV2BillingAccountsByCodePushToBillingSystemResponses = {
  /**
   * OK
   */
  200: PushBillingAccountToBillingSystemResultDto;
};

export type PostV2BillingAccountsByCodePushToBillingSystemResponse =
  PostV2BillingAccountsByCodePushToBillingSystemResponses[keyof PostV2BillingAccountsByCodePushToBillingSystemResponses];

export type GetV2BillingAccountsByCodeIntegrationAttemptsData = {
  body?: never;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/integration-attempts";
};

export type GetV2BillingAccountsByCodeIntegrationAttemptsResponses = {
  /**
   * OK
   */
  200: Array<IntegrationAttemptDto>;
};

export type GetV2BillingAccountsByCodeIntegrationAttemptsResponse =
  GetV2BillingAccountsByCodeIntegrationAttemptsResponses[keyof GetV2BillingAccountsByCodeIntegrationAttemptsResponses];

export type DeleteV2BillingAccountsByCodeContactsByContactIdData = {
  body?: never;
  path: {
    code: string;
    contactId: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/contacts/{contactId}";
};

export type DeleteV2BillingAccountsByCodeContactsByContactIdResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type PutV2BillingAccountsByCodeContactsByContactIdData = {
  body?: SaveContactDto;
  path: {
    code: string;
    contactId: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/contacts/{contactId}";
};

export type PutV2BillingAccountsByCodeContactsByContactIdResponses = {
  /**
   * OK
   */
  200: ContactDto;
};

export type PutV2BillingAccountsByCodeContactsByContactIdResponse =
  PutV2BillingAccountsByCodeContactsByContactIdResponses[keyof PutV2BillingAccountsByCodeContactsByContactIdResponses];

export type PostV2BillingAccountsByCodeContactsByContactIdRedactData = {
  body?: RedactContactDto;
  path: {
    code: string;
    contactId: string;
  };
  query?: never;
  url: "/v2/billing-accounts/{code}/contacts/{contactId}/redact";
};

export type PostV2BillingAccountsByCodeContactsByContactIdRedactResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetV2ConfigurationFeaturesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v2/configuration/features";
};

export type GetV2ConfigurationFeaturesResponses = {
  /**
   * OK
   */
  200: {
    [key: string]: boolean;
  };
};

export type GetV2ConfigurationFeaturesResponse =
  GetV2ConfigurationFeaturesResponses[keyof GetV2ConfigurationFeaturesResponses];

export type GetV2CountriesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v2/countries";
};

export type GetV2CountriesResponses = {
  /**
   * OK
   */
  200: Array<CountryDto>;
};

export type GetV2CountriesResponse = GetV2CountriesResponses[keyof GetV2CountriesResponses];

export type GetV2FulfillmentsData = {
  body?: never;
  path?: never;
  query: {
    orderNumber: string;
  };
  url: "/v2/fulfillments";
};

export type GetV2FulfillmentsResponses = {
  /**
   * OK
   */
  200: OrderFulfillmentDto;
};

export type GetV2FulfillmentsResponse = GetV2FulfillmentsResponses[keyof GetV2FulfillmentsResponses];

export type GetV2FulfillmentsByFulfillmentIdData = {
  body?: never;
  path: {
    fulfillmentId: string;
  };
  query?: never;
  url: "/v2/fulfillments/{fulfillmentId}";
};

export type GetV2FulfillmentsByFulfillmentIdResponses = {
  /**
   * OK
   */
  200: OrderFulfillmentDto;
};

export type GetV2FulfillmentsByFulfillmentIdResponse =
  GetV2FulfillmentsByFulfillmentIdResponses[keyof GetV2FulfillmentsByFulfillmentIdResponses];

export type GetV2FulfillmentsByFulfillmentIdHistoryData = {
  body?: never;
  path: {
    fulfillmentId: string;
  };
  query?: never;
  url: "/v2/fulfillments/{fulfillmentId}/history";
};

export type GetV2FulfillmentsByFulfillmentIdHistoryResponses = {
  /**
   * OK
   */
  200: Array<FulfillmentHistoryEntryDto>;
};

export type GetV2FulfillmentsByFulfillmentIdHistoryResponse =
  GetV2FulfillmentsByFulfillmentIdHistoryResponses[keyof GetV2FulfillmentsByFulfillmentIdHistoryResponses];

export type GetV2LegalTermsData = {
  body?: never;
  path?: never;
  query?: {
    includeWithdrawn?: boolean;
  };
  url: "/v2/legal-terms";
};

export type GetV2LegalTermsResponses = {
  /**
   * OK
   */
  200: Array<PreapprovedLegalTermDto>;
};

export type GetV2LegalTermsResponse = GetV2LegalTermsResponses[keyof GetV2LegalTermsResponses];

export type GetV2LicensesOctopusCloudByIdData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/licenses/OctopusCloud/{id}";
};

export type GetV2LicensesOctopusCloudByIdResponses = {
  /**
   * OK
   */
  200: CloudSubscriptionDto;
};

export type GetV2LicensesOctopusCloudByIdResponse =
  GetV2LicensesOctopusCloudByIdResponses[keyof GetV2LicensesOctopusCloudByIdResponses];

export type GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdData = {
  body?: never;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/licenses/OctopusCloud/subscription/{subscriptionId}";
};

export type GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponses = {
  /**
   * OK
   */
  200: CloudSubscriptionDto;
};

export type GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponse =
  GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponses[keyof GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponses];

export type GetV2LicensesOctopusCloudSerialBySerialData = {
  body?: never;
  path: {
    serial: string;
  };
  query?: never;
  url: "/v2/licenses/OctopusCloud/serial/{serial}";
};

export type GetV2LicensesOctopusCloudSerialBySerialResponses = {
  /**
   * OK
   */
  200: CloudSubscriptionDto;
};

export type GetV2LicensesOctopusCloudSerialBySerialResponse =
  GetV2LicensesOctopusCloudSerialBySerialResponses[keyof GetV2LicensesOctopusCloudSerialBySerialResponses];

export type GetV2LicensesOctopusServerByIdData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/licenses/OctopusServer/{id}";
};

export type GetV2LicensesOctopusServerByIdResponses = {
  /**
   * OK
   */
  200: ServerLicenseDto;
};

export type GetV2LicensesOctopusServerByIdResponse =
  GetV2LicensesOctopusServerByIdResponses[keyof GetV2LicensesOctopusServerByIdResponses];

export type GetV2LicensesOctopusServerSubscriptionBySubscriptionIdData = {
  body?: never;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/licenses/OctopusServer/subscription/{subscriptionId}";
};

export type GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponses = {
  /**
   * OK
   */
  200: ServerLicenseDto;
};

export type GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponse =
  GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponses[keyof GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponses];

export type GetV2LicensesOctopusServerSerialBySerialData = {
  body?: never;
  path: {
    serial: string;
  };
  query?: never;
  url: "/v2/licenses/OctopusServer/serial/{serial}";
};

export type GetV2LicensesOctopusServerSerialBySerialResponses = {
  /**
   * OK
   */
  200: ServerLicenseDto;
};

export type GetV2LicensesOctopusServerSerialBySerialResponse =
  GetV2LicensesOctopusServerSerialBySerialResponses[keyof GetV2LicensesOctopusServerSerialBySerialResponses];

export type GetV2OrdersData = {
  body?: never;
  path?: never;
  query?: {
    status?: OrderStatus;
    salesMotion?: SalesMotion;
    salesRep?: string;
    selfServeOnly?: boolean;
    reviewRequired?: boolean;
    search?: string;
    includeArchived?: boolean;
    page?: number;
    pageSize?: number;
  };
  url: "/v2/orders";
};

export type GetV2OrdersResponses = {
  /**
   * OK
   */
  200: OrderSummaryDtoListResponse;
};

export type GetV2OrdersResponse = GetV2OrdersResponses[keyof GetV2OrdersResponses];

export type PostV2OrdersData = {
  body?: CreateOrderDto;
  path?: never;
  query?: never;
  url: "/v2/orders";
};

export type PostV2OrdersResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersResponse = PostV2OrdersResponses[keyof PostV2OrdersResponses];

export type GetV2OrdersSearchData = {
  body?: never;
  path?: never;
  query: {
    term: string;
  };
  url: "/v2/orders/search";
};

export type GetV2OrdersSearchResponses = {
  /**
   * OK
   */
  200: QuoteTargetSearchResultDto;
};

export type GetV2OrdersSearchResponse = GetV2OrdersSearchResponses[keyof GetV2OrdersSearchResponses];

export type GetV2OrdersSalesRepsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v2/orders/sales-reps";
};

export type GetV2OrdersSalesRepsResponses = {
  /**
   * OK
   */
  200: Array<string>;
};

export type GetV2OrdersSalesRepsResponse = GetV2OrdersSalesRepsResponses[keyof GetV2OrdersSalesRepsResponses];

export type GetV2OrdersResellersData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
  };
  url: "/v2/orders/resellers";
};

export type GetV2OrdersResellersResponses = {
  /**
   * OK
   */
  200: OrderResellersDto;
};

export type GetV2OrdersResellersResponse = GetV2OrdersResellersResponses[keyof GetV2OrdersResellersResponses];

export type GetV2OrdersByOdNumberData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}";
};

export type GetV2OrdersByOdNumberResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type GetV2OrdersByOdNumberResponse = GetV2OrdersByOdNumberResponses[keyof GetV2OrdersByOdNumberResponses];

export type PutV2OrdersByOdNumberData = {
  body?: UpdateOrderDto;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}";
};

export type PutV2OrdersByOdNumberResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PutV2OrdersByOdNumberResponse = PutV2OrdersByOdNumberResponses[keyof PutV2OrdersByOdNumberResponses];

export type GetV2OrdersByOdNumberDocumentData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/document";
};

export type GetV2OrdersByOdNumberDocumentResponses = {
  /**
   * OK
   */
  200: QuoteDocumentContent;
};

export type GetV2OrdersByOdNumberDocumentResponse =
  GetV2OrdersByOdNumberDocumentResponses[keyof GetV2OrdersByOdNumberDocumentResponses];

export type GetV2OrdersByOdNumberHistoryData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/history";
};

export type GetV2OrdersByOdNumberHistoryResponses = {
  /**
   * OK
   */
  200: Array<OrderHistoryEntryDto>;
};

export type GetV2OrdersByOdNumberHistoryResponse =
  GetV2OrdersByOdNumberHistoryResponses[keyof GetV2OrdersByOdNumberHistoryResponses];

export type GetV2OrdersByOdNumberContactsData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/contacts";
};

export type GetV2OrdersByOdNumberContactsResponses = {
  /**
   * OK
   */
  200: OrderContactsDto;
};

export type GetV2OrdersByOdNumberContactsResponse =
  GetV2OrdersByOdNumberContactsResponses[keyof GetV2OrdersByOdNumberContactsResponses];

export type GetV2OrdersByOdNumberFulfillmentData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/fulfillment";
};

export type GetV2OrdersByOdNumberFulfillmentResponses = {
  /**
   * OK
   */
  200: OrderFulfillmentDto;
};

export type GetV2OrdersByOdNumberFulfillmentResponse =
  GetV2OrdersByOdNumberFulfillmentResponses[keyof GetV2OrdersByOdNumberFulfillmentResponses];

export type GetV2OrdersByOdNumberRateCardOperationsData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/rate-card-operations";
};

export type GetV2OrdersByOdNumberRateCardOperationsResponses = {
  /**
   * OK
   */
  200: OrderRateCardOperationsDto;
};

export type GetV2OrdersByOdNumberRateCardOperationsResponse =
  GetV2OrdersByOdNumberRateCardOperationsResponses[keyof GetV2OrdersByOdNumberRateCardOperationsResponses];

export type PostV2OrdersByOdNumberPricePreviewData = {
  body?: PreviewOrderPriceDto;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/price-preview";
};

export type PostV2OrdersByOdNumberPricePreviewResponses = {
  /**
   * OK
   */
  200: PriceBreakdown;
};

export type PostV2OrdersByOdNumberPricePreviewResponse =
  PostV2OrdersByOdNumberPricePreviewResponses[keyof PostV2OrdersByOdNumberPricePreviewResponses];

export type PostV2OrdersByOdNumberRateCardCloneData = {
  body?: RateCardTermsDto;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/rate-card/clone";
};

export type PostV2OrdersByOdNumberRateCardCloneResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberRateCardCloneResponse =
  PostV2OrdersByOdNumberRateCardCloneResponses[keyof PostV2OrdersByOdNumberRateCardCloneResponses];

export type PostV2OrdersByOdNumberRateCardPlanDefaultData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/rate-card/plan-default";
};

export type PostV2OrdersByOdNumberRateCardPlanDefaultResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberRateCardPlanDefaultResponse =
  PostV2OrdersByOdNumberRateCardPlanDefaultResponses[keyof PostV2OrdersByOdNumberRateCardPlanDefaultResponses];

export type PostV2OrdersByOdNumberMakeLiveData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/make-live";
};

export type PostV2OrdersByOdNumberMakeLiveResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberMakeLiveResponse =
  PostV2OrdersByOdNumberMakeLiveResponses[keyof PostV2OrdersByOdNumberMakeLiveResponses];

export type PostV2OrdersByOdNumberRetractData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/retract";
};

export type PostV2OrdersByOdNumberRetractResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberRetractResponse =
  PostV2OrdersByOdNumberRetractResponses[keyof PostV2OrdersByOdNumberRetractResponses];

export type PostV2OrdersByOdNumberCancelData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/cancel";
};

export type PostV2OrdersByOdNumberCancelResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberCancelResponse =
  PostV2OrdersByOdNumberCancelResponses[keyof PostV2OrdersByOdNumberCancelResponses];

export type PostV2OrdersByOdNumberReopenData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/reopen";
};

export type PostV2OrdersByOdNumberReopenResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberReopenResponse =
  PostV2OrdersByOdNumberReopenResponses[keyof PostV2OrdersByOdNumberReopenResponses];

export type PostV2OrdersByOdNumberArchiveData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/archive";
};

export type PostV2OrdersByOdNumberArchiveResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberArchiveResponse =
  PostV2OrdersByOdNumberArchiveResponses[keyof PostV2OrdersByOdNumberArchiveResponses];

export type PostV2OrdersByOdNumberAcceptData = {
  body?: AcceptOrderDto;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/accept";
};

export type PostV2OrdersByOdNumberAcceptResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PostV2OrdersByOdNumberAcceptResponse =
  PostV2OrdersByOdNumberAcceptResponses[keyof PostV2OrdersByOdNumberAcceptResponses];

export type PutV2OrdersByOdNumberInternalConfirmationData = {
  body?: SetInternalConfirmationDto;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/internal-confirmation";
};

export type PutV2OrdersByOdNumberInternalConfirmationResponses = {
  /**
   * OK
   */
  200: OrderDto;
};

export type PutV2OrdersByOdNumberInternalConfirmationResponse =
  PutV2OrdersByOdNumberInternalConfirmationResponses[keyof PutV2OrdersByOdNumberInternalConfirmationResponses];

export type PostV2OrdersByOdNumberTaxEstimateData = {
  body?: never;
  path: {
    odNumber: string;
  };
  query?: never;
  url: "/v2/orders/{odNumber}/tax-estimate";
};

export type PostV2OrdersByOdNumberTaxEstimateResponses = {
  /**
   * OK
   */
  200: OrderTaxEstimatePreviewResultDto;
};

export type PostV2OrdersByOdNumberTaxEstimateResponse =
  PostV2OrdersByOdNumberTaxEstimateResponses[keyof PostV2OrdersByOdNumberTaxEstimateResponses];

export type GetV2PlansData = {
  body?: never;
  path?: never;
  query?: {
    platform?: ProductPlatform;
    tier?: Tier;
    availableDate?: string;
    page?: number;
    pageSize?: number;
  };
  url: "/v2/plans";
};

export type GetV2PlansResponses = {
  /**
   * OK
   */
  200: PlanListResponse;
};

export type GetV2PlansResponse = GetV2PlansResponses[keyof GetV2PlansResponses];

export type GetV2PlansByIdData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/plans/{id}";
};

export type GetV2PlansByIdResponses = {
  /**
   * OK
   */
  200: Plan;
};

export type GetV2PlansByIdResponse = GetV2PlansByIdResponses[keyof GetV2PlansByIdResponses];

export type GetV2PlansPlatformByPlatformData = {
  body?: never;
  path: {
    platform: ProductPlatform;
  };
  query?: {
    tier?: Tier;
  };
  url: "/v2/plans/platform/{platform}";
};

export type GetV2PlansPlatformByPlatformResponses = {
  /**
   * OK
   */
  200: Array<Plan>;
};

export type GetV2PlansPlatformByPlatformResponse =
  GetV2PlansPlatformByPlatformResponses[keyof GetV2PlansPlatformByPlatformResponses];

export type GetV2RateCardsData = {
  body?: never;
  path?: never;
  query?: {
    code?: string;
    label?: string;
    search?: string;
    page?: number;
    pageSize?: number;
    sortFieldName?: string;
    sortDirection?: SortDirection;
  };
  url: "/v2/rate-cards";
};

export type GetV2RateCardsResponses = {
  /**
   * OK
   */
  200: RateCardListResponse;
};

export type GetV2RateCardsResponse = GetV2RateCardsResponses[keyof GetV2RateCardsResponses];

export type PostV2RateCardsData = {
  body?: RateCardTermsDto;
  path?: never;
  query?: never;
  url: "/v2/rate-cards";
};

export type PostV2RateCardsResponses = {
  /**
   * OK
   */
  200: RateCard;
};

export type PostV2RateCardsResponse = PostV2RateCardsResponses[keyof PostV2RateCardsResponses];

export type GetV2RateCardsByCodeData = {
  body?: never;
  path: {
    code: string;
  };
  query?: never;
  url: "/v2/rate-cards/{code}";
};

export type GetV2RateCardsByCodeResponses = {
  /**
   * OK
   */
  200: RateCard;
};

export type GetV2RateCardsByCodeResponse = GetV2RateCardsByCodeResponses[keyof GetV2RateCardsByCodeResponses];

export type PostV2RateCardsBulkAssignData = {
  body?: BulkAssignRateCardsRequestDto;
  path?: never;
  query?: never;
  url: "/v2/rate-cards/bulk-assign";
};

export type PostV2RateCardsBulkAssignResponses = {
  /**
   * OK
   */
  200: BulkAssignRateCardsResponseDto;
};

export type PostV2RateCardsBulkAssignResponse =
  PostV2RateCardsBulkAssignResponses[keyof PostV2RateCardsBulkAssignResponses];

export type PostV2RateCardsPreviewData = {
  body?: PreviewSubscriptionPriceDto;
  path?: never;
  query?: never;
  url: "/v2/rate-cards/preview";
};

export type PostV2RateCardsPreviewResponses = {
  /**
   * OK
   */
  200: PriceBreakdown;
};

export type PostV2RateCardsPreviewResponse = PostV2RateCardsPreviewResponses[keyof PostV2RateCardsPreviewResponses];

export type DeleteV2SubscriptionsBySubscriptionIdBillingAccountData = {
  body?: never;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/billing-account";
};

export type DeleteV2SubscriptionsBySubscriptionIdBillingAccountResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type PostV2SubscriptionsBySubscriptionIdBillingAccountData = {
  body?: AssignSubscriptionToBillingAccountDto;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/billing-account";
};

export type PostV2SubscriptionsBySubscriptionIdBillingAccountResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewData = {
  body?: never;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/billing-account/transfer-preview";
};

export type GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponses = {
  /**
   * OK
   */
  200: SubscriptionTransferPreviewDto;
};

export type GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponse =
  GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponses[keyof GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponses];

export type PostV2SubscriptionsBySubscriptionIdRateCardDraftsData = {
  body?: DraftRateCardAssignmentDto;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/rate-card-drafts";
};

export type PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponses = {
  /**
   * OK
   */
  200: DraftRateCardAssignmentResponse;
};

export type PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponse =
  PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponses[keyof PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponses];

export type PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateData = {
  body?: never;
  path: {
    subscriptionId: string;
    assignmentId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/rate-card-drafts/{assignmentId}/activate";
};

export type PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponses = {
  /**
   * OK
   */
  200: SubscriptionRateCardAssignment;
};

export type PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponse =
  PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponses[keyof PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponses];

export type GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryData = {
  body?: never;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/rate-card-assignments/history";
};

export type GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponses = {
  /**
   * OK
   */
  200: Array<RateCardAssignmentHistoryEntry>;
};

export type GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponse =
  GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponses[keyof GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponses];

export type PostV2SubscriptionsBySubscriptionIdRateCardCalculateData = {
  body?: CalculateSubscriptionPriceDto;
  path: {
    subscriptionId: string;
  };
  query?: never;
  url: "/v2/subscriptions/{subscriptionId}/rate-card/calculate";
};

export type PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponses = {
  /**
   * OK
   */
  200: PriceBreakdown;
};

export type PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponse =
  PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponses[keyof PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponses];

export type GetV2SubscriptionsData = {
  body?: never;
  path?: never;
  query?: {
    status?: SubscriptionStatus;
    lifecycleType?: LifecycleType;
    complimentaryType?: ComplimentaryType;
    tier?: Tier;
    page?: number;
    pageSize?: number;
    serial?: string;
    dnsPrefix?: string;
    ownerEmail?: string;
    termStartAfter?: string;
    termStartBefore?: string;
    termEndAfter?: string;
    termEndBefore?: string;
    zuoraSubscriptionKey?: string;
    friendlyName?: string;
    rateCardCode?: string;
    sortFieldName?: string;
    sortDirection?: SortDirection;
  };
  url: "/v2/subscriptions";
};

export type GetV2SubscriptionsResponses = {
  /**
   * OK
   */
  200: SubscriptionWithSerialListResponse;
};

export type GetV2SubscriptionsResponse = GetV2SubscriptionsResponses[keyof GetV2SubscriptionsResponses];

export type PostV2SubscriptionsData = {
  body?: CreateSubscriptionDto;
  path?: never;
  query?: never;
  url: "/v2/subscriptions";
};

export type PostV2SubscriptionsResponses = {
  /**
   * OK
   */
  200: CreateSubscriptionResponse;
};

export type PostV2SubscriptionsResponse = PostV2SubscriptionsResponses[keyof PostV2SubscriptionsResponses];

export type GetV2SubscriptionsByIdData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}";
};

export type GetV2SubscriptionsByIdResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type GetV2SubscriptionsByIdResponse = GetV2SubscriptionsByIdResponses[keyof GetV2SubscriptionsByIdResponses];

export type PatchV2SubscriptionsByIdData = {
  body?: UpdateSubscriptionRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}";
};

export type PatchV2SubscriptionsByIdResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PatchV2SubscriptionsByIdResponse =
  PatchV2SubscriptionsByIdResponses[keyof PatchV2SubscriptionsByIdResponses];

export type GetV2SubscriptionsByIdHistorySnapshotData = {
  body?: never;
  path: {
    id: string;
  };
  query?: {
    asOf?: string;
  };
  url: "/v2/subscriptions/{id}/history-snapshot";
};

export type GetV2SubscriptionsByIdHistorySnapshotResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type PatchV2SubscriptionsByIdSelfServiceEnabledData = {
  body?: UpdateSelfServiceEnabledRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/self-service-enabled";
};

export type PatchV2SubscriptionsByIdSelfServiceEnabledResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PatchV2SubscriptionsByIdSelfServiceEnabledResponse =
  PatchV2SubscriptionsByIdSelfServiceEnabledResponses[keyof PatchV2SubscriptionsByIdSelfServiceEnabledResponses];

export type PatchV2SubscriptionsByIdEntitlementOverridesData = {
  body?: UpdateSubscriptionEntitlementOverridesRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/entitlement-overrides";
};

export type PatchV2SubscriptionsByIdEntitlementOverridesResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PatchV2SubscriptionsByIdEntitlementOverridesResponse =
  PatchV2SubscriptionsByIdEntitlementOverridesResponses[keyof PatchV2SubscriptionsByIdEntitlementOverridesResponses];

export type PatchV2SubscriptionsByIdAutoRenewalData = {
  body?: never;
  path: {
    id: string;
  };
  query?: {
    request?: UpdateComplimentaryAutoRenewalRequest;
  };
  url: "/v2/subscriptions/{id}/auto-renewal";
};

export type PatchV2SubscriptionsByIdAutoRenewalResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PatchV2SubscriptionsByIdAutoRenewalResponse =
  PatchV2SubscriptionsByIdAutoRenewalResponses[keyof PatchV2SubscriptionsByIdAutoRenewalResponses];

export type PatchV2SubscriptionsByIdZuoraSubscriptionKeyData = {
  body?: UpdateZuoraSubscriptionKeyRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/zuora-subscription-key";
};

export type PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponse =
  PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponses[keyof PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponses];

export type PatchV2SubscriptionsByIdPlanData = {
  body?: ChangeSubscriptionPlanRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/plan";
};

export type PatchV2SubscriptionsByIdPlanResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PatchV2SubscriptionsByIdPlanResponse =
  PatchV2SubscriptionsByIdPlanResponses[keyof PatchV2SubscriptionsByIdPlanResponses];

export type PostV2SubscriptionsByIdCancelData = {
  body?: CancelSubscriptionRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/cancel";
};

export type PostV2SubscriptionsByIdCancelResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdCancelResponse =
  PostV2SubscriptionsByIdCancelResponses[keyof PostV2SubscriptionsByIdCancelResponses];

export type PostV2SubscriptionsByIdReactivateData = {
  body?: ReactivateSubscriptionRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/reactivate";
};

export type PostV2SubscriptionsByIdReactivateResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdReactivateResponse =
  PostV2SubscriptionsByIdReactivateResponses[keyof PostV2SubscriptionsByIdReactivateResponses];

export type PostV2SubscriptionsByIdExtendTermData = {
  body?: ExtendSubscriptionTermRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/extend-term";
};

export type PostV2SubscriptionsByIdExtendTermResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdExtendTermResponse =
  PostV2SubscriptionsByIdExtendTermResponses[keyof PostV2SubscriptionsByIdExtendTermResponses];

export type PostV2SubscriptionsByIdTransitionToComplimentaryData = {
  body?: TransitionToComplimentaryRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/transition-to-complimentary";
};

export type PostV2SubscriptionsByIdTransitionToComplimentaryResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdTransitionToComplimentaryResponse =
  PostV2SubscriptionsByIdTransitionToComplimentaryResponses[keyof PostV2SubscriptionsByIdTransitionToComplimentaryResponses];

export type PostV2SubscriptionsByIdTransitionToPaidData = {
  body?: TransitionToPaidRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/transition-to-paid";
};

export type PostV2SubscriptionsByIdTransitionToPaidResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdTransitionToPaidResponse =
  PostV2SubscriptionsByIdTransitionToPaidResponses[keyof PostV2SubscriptionsByIdTransitionToPaidResponses];

export type PostV2SubscriptionsByIdTransitionToTrialData = {
  body?: TransitionToTrialRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/transition-to-trial";
};

export type PostV2SubscriptionsByIdTransitionToTrialResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdTransitionToTrialResponse =
  PostV2SubscriptionsByIdTransitionToTrialResponses[keyof PostV2SubscriptionsByIdTransitionToTrialResponses];

export type PostV2SubscriptionsByIdTransitionToEvergreenData = {
  body?: TransitionToEvergreenRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/transition-to-evergreen";
};

export type PostV2SubscriptionsByIdTransitionToEvergreenResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdTransitionToEvergreenResponse =
  PostV2SubscriptionsByIdTransitionToEvergreenResponses[keyof PostV2SubscriptionsByIdTransitionToEvergreenResponses];

export type PostV2SubscriptionsByIdDowngradeToFreeData = {
  body?: DowngradeToFreeRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/downgrade-to-free";
};

export type PostV2SubscriptionsByIdDowngradeToFreeResponses = {
  /**
   * OK
   */
  200: ComplimentarySubscription | EvergreenSubscription | PaidSubscription | TrialSubscription;
};

export type PostV2SubscriptionsByIdDowngradeToFreeResponse =
  PostV2SubscriptionsByIdDowngradeToFreeResponses[keyof PostV2SubscriptionsByIdDowngradeToFreeResponses];

export type GetV2SubscriptionsTrialEntitlementsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v2/subscriptions/trial-entitlements";
};

export type GetV2SubscriptionsTrialEntitlementsResponses = {
  /**
   * OK
   */
  200: GetTrialEntitlementsResponse;
};

export type GetV2SubscriptionsTrialEntitlementsResponse =
  GetV2SubscriptionsTrialEntitlementsResponses[keyof GetV2SubscriptionsTrialEntitlementsResponses];

export type GetV2SubscriptionsByIdHistoryData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/history";
};

export type GetV2SubscriptionsByIdHistoryResponses = {
  /**
   * OK
   */
  200: Array<EntityHistoryReferenceDto>;
};

export type GetV2SubscriptionsByIdHistoryResponse =
  GetV2SubscriptionsByIdHistoryResponses[keyof GetV2SubscriptionsByIdHistoryResponses];

export type GetV2SubscriptionsByIdLicenseEmailsData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/license-emails";
};

export type GetV2SubscriptionsByIdLicenseEmailsResponses = {
  /**
   * OK
   */
  200: Array<LicenseEmailDto>;
};

export type GetV2SubscriptionsByIdLicenseEmailsResponse =
  GetV2SubscriptionsByIdLicenseEmailsResponses[keyof GetV2SubscriptionsByIdLicenseEmailsResponses];

export type PostV2SubscriptionsByIdLicenseEmailsData = {
  body?: SendLicenseEmailRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/license-emails";
};

export type PostV2SubscriptionsByIdLicenseEmailsResponses = {
  /**
   * OK
   */
  200: LicenseEmailDto;
};

export type PostV2SubscriptionsByIdLicenseEmailsResponse =
  PostV2SubscriptionsByIdLicenseEmailsResponses[keyof PostV2SubscriptionsByIdLicenseEmailsResponses];

export type GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/v2/subscriptions/{id}/license-emails/default-recipients";
};

export type GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponses = {
  /**
   * OK
   */
  200: LicenseEmailDefaultRecipientsDto;
};

export type GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponse =
  GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponses[keyof GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponses];
